/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-03T10:29:11.932
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentPublishChannelConfig,
	getRentPublishChannelConfigCreateInit,
	getRentPublishChannelConfigEditInit,
	getRentPublishChannelConfigView,
	deleteRentPublishChannelConfig
} from '@api/rentmanage/RentPublishChannelConfig';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentPublishChannelConfigCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelConfigCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPublishChannelConfigEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelConfigEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentPublishChannelConfig({}, RentPublishChannelConfig) {
			return new Promise((resolve, reject) => {
				saveRentPublishChannelConfig(RentPublishChannelConfig)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPublishChannelConfigView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelConfigView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPublishChannelConfig({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPublishChannelConfig({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
